module.exports = __webpack_public_path__ + "img/galaxis.d14569e0.svg";